module.exports = __webpack_public_path__ + "img/i-logout-admin.c334abb2.svg";